export { default } from "./ImgCard";



// WEBPACK FOOTER //
// ./src/components/ImgCard/index.js